// Дарунок за встановлення Android-додатка: +3 дні Premium, один раз на акаунт.
// Викликається ТІЛЬКИ з нативної апки; сервер сам не дасть нарахувати двічі.
import { useEffect, useRef, useState } from 'react';
import { api } from '../lib/api';
import { isNativeApp } from '../lib/push';
import { haptic } from '../lib/telegram';
import { IconTile } from './AppIcons';

const LOCAL_FLAG = 'appBonusChecked';

export function AppBonus() {
  const [days, setDays] = useState<number | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!isNativeApp()) return;
    // Щоб не смикати сервер на кожен запуск — питаємо один раз на пристрій
    if (localStorage.getItem(LOCAL_FLAG)) return;
    void (async () => {
      try {
        const res = await api.premium.appBonus();
        localStorage.setItem(LOCAL_FLAG, '1');
        if (res.granted && res.days) {
          haptic.success();
          setDays(res.days);
        }
      } catch {
        /* нема мережі — спробуємо наступного запуску (прапорець не ставимо) */
      }
    })();
  }, []);

  if (days === null) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-6">
      <div className="card w-full max-w-sm space-y-4 text-center">
        <div className="flex justify-center">
          <IconTile kind="gift" className="h-14 w-14" glyphClass="h-8 w-8" />
        </div>
        <div className="text-lg font-bold text-tg-text">Дякуємо за встановлення! 🎉</div>
        <div className="text-sm text-tg-hint">
          Тобі нараховано <span className="font-semibold text-tg-success">{days} дні Premium</span> —
          усі режими вже відкриті.
        </div>
        <button
          onClick={() => {
            haptic.light();
            setDays(null);
            // Оновлюємо сторінку, щоб статус Premium підтягнувся всюди
            window.location.reload();
          }}
          className="btn-primary w-full bg-tg-success text-white"
        >
          Круто, почати
        </button>
      </div>
    </div>
  );
}
